var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:8;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464,144h-39.3c9.5-13.4,15.3-29.9,15.3-48c0-44.1-33.4-80-74.5-80c-42.3,0-66.8,25.4-109.5,95.8 C213.3,41.4,188.8,16,146.5,16C105.4,16,72,51.9,72,96c0,18.1,5.8,34.6,15.3,48H48c-26.5,0-48,21.5-48,48v96c0,8.8,7.2,16,16,16h16 v144c0,26.5,21.5,48,48,48h352c26.5,0,48-21.5,48-48V304h16c8.8,0,16-7.2,16-16v-96C512,165.5,490.5,144,464,144z M276.2,140.4 c49.5-83.3,66-92.4,89.3-92.4c23.4,0,42.5,21.5,42.5,48s-19.1,48-42.5,48H274L276.2,140.4z M146.5,48c23.4,0,39.8,9.1,89.3,92.4 l2.1,3.6h-91.5c-23.4,0-42.5-21.5-42.5-48C104,69.5,123.1,48,146.5,48z M192,464H80c-8.8,0-16-7.2-16-16V304h128V464z M192,272H32 v-80c0-8.8,7.2-16,16-16h144V272z M288,464h-64V176h64V464z M448,448c0,8.8-7.2,16-16,16H320V304h128V448z M480,272H320v-96h144 c8.8,0,16,7.2,16,16V272z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.0b76c61e1c1670ae458e4ca779502bbc.svg";
export { ForwardRef as ReactComponent };